import React from 'react';
import { ILowesProductTexture } from '../../../../entities-generated/common/lowes/lowes-product-texture';
import { BwjListing } from '../../../../framework/components/bwj-listing';
import { BadgeType } from '../../../../framework/components/bwj-listing/entities';

interface ILowesProductVariantListItemProps {
  variant: ILowesProductTexture;
  onClick: (variant: ILowesProductTexture) => void;
}

export const LowesProductVariantListItem: React.FunctionComponent<ILowesProductVariantListItemProps> = (props) => {
  const { variant } = props;

  return (
    <BwjListing
      heading={variant.value}
      badge={{
        type: BadgeType.Image,
        content: variant.swatchImage
      }}
      loadImage={true}
      data={variant}
      onClick={props.onClick}
    />
  );
};
